export default {
  'forgotPassSuccess.title': 'Yêu cầu của bạn đã được ghi nhận!',
  'forgotPassSuccess.sub.title':
    'Một email với hướng dẫn cài đặt lại mật khẩu đã được gửi đến địa chỉ email đăng ký của bạn.',
  'forgotPassSuccess.sub.title1':
    'Nếu bạn không nhận được email có chứa đường dẫn thay đổi mật khẩu trong một vài phút tới, hãy kiểm tra mục Thư rác.',
  'forgotPassSuccess.button.signIn': 'OK',
};
